// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  background-color: #DDE8B9;
  font-family: 'Staatliches', sans-serif;
}

/* Layout Wrapper */
.kernteamportal-wrapper {
  padding: 2rem;
}

.area-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, max-content));
  gap: 0.3rem;
  justify-content: center;
  padding: 0 0.5rem;
  margin-top: 1rem;
}

/* Karte mit GRID */
.area-card {
  background-color: #ccc;
  border-radius: 20px;
  padding: 1rem;
  color: white;
  cursor: pointer;
  transition: transform 0.2s ease;
  display: flex;
  flex-direction: column;
  text-align: left;
  height: auto;
  min-height: 400px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 420px;
  font-weight: normal;
}


/* Hover Effekt */
.area-card:hover {
  transform: translateY(-5px);
}

/* Titel */
.area-card h2 {
  font-size: 1.8rem;
  font-family: 'Staatliches', sans-serif;
  margin: 0;
  text-transform: uppercase;
  color: white;
  font-weight: normal;
}

/* Beschreibung */
.area-card p {
  font-size: 1rem;
  color: white;
  line-height: 1.5;
  margin: 0;
  font-weight: normal;
  font-family: 'Circular', sans-serif;
  text-transform: none;
}

/* Farben für einzelne Bereiche */
.area-card.arbeit {
  background-color: #F4AF20;
}

.area-card.freizeit {
  background-color: #ee5522;
}

.area-card.listen {
  background-color: #0077c8;
}

.area-card.kinder {
  background-color: #648202;
}

.area-card.parlament {
  background-color: #0074B3;
}

.area-card.logistik {
  background-color: var(--logistik);
}



/* Login Screen */
.login-screen {
  height: 100vh;
  background-color: #DDE8B9;
  display: flex;
  align-items: center;
  justify-content: center;
}



.login-screen form {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}

.login-screen input {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #aaa;
  font-family: 'Circular', sans-serif;
}

.login-screen button {
  background-color: #648202;
  color: #FFFFFF;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: normal;
  font-family: 'Circular', sans-serif;
  text-transform: uppercase;
}

.login-screen button:hover {
  background-color: #5a7502;
}

.area-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  width: 100%;
  font-weight: normal;
}

.area-content h2 {
  font-size: 1.8rem;
  font-family: 'Staatliches', sans-serif;
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  color: white;
  text-align: left;
  font-weight: normal;
}

/* Beschreibung */
.area-content p {
  font-size: 1rem;
  color: white;
  line-height: 1.5;
  margin: 0;
  text-align: left !important;
  font-weight: normal;
  font-family: 'Circular', sans-serif;
  text-transform: none;
}

.footer-link {
  text-align: center;
  margin-top: 2rem;
  font-size: 1rem;
}

.footer-link a {
  color: #00509E;
  text-decoration: underline;
  text-underline-offset: 4px;
  font-weight: normal;
  transition: color 0.2s ease;
}

.footer-link a:hover {
  color: #e48f2d;
}

@media (max-width: 768px) {
  .area-container {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .area-icon {
    font-size: 8rem !important;
  }
}

@media (max-width: 480px) {
  .area-card {
    min-height: 300px;
  }

  .area-icon {
    font-size: 6rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Kernteamportal.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA,iBAAiB;AACjB;EACE,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,sCAAsC;EACtC,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;;;AAIA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;;AAIA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  background-color: #DDE8B9;\n  font-family: 'Staatliches', sans-serif;\n}\n\n/* Layout Wrapper */\n.kernteamportal-wrapper {\n  padding: 2rem;\n}\n\n.area-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(420px, max-content));\n  gap: 0.3rem;\n  justify-content: center;\n  padding: 0 0.5rem;\n  margin-top: 1rem;\n}\n\n/* Karte mit GRID */\n.area-card {\n  background-color: #ccc;\n  border-radius: 20px;\n  padding: 1rem;\n  color: white;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  height: auto;\n  min-height: 400px;\n  width: 100%;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  max-width: 420px;\n  font-weight: normal;\n}\n\n\n/* Hover Effekt */\n.area-card:hover {\n  transform: translateY(-5px);\n}\n\n/* Titel */\n.area-card h2 {\n  font-size: 1.8rem;\n  font-family: 'Staatliches', sans-serif;\n  margin: 0;\n  text-transform: uppercase;\n  color: white;\n  font-weight: normal;\n}\n\n/* Beschreibung */\n.area-card p {\n  font-size: 1rem;\n  color: white;\n  line-height: 1.5;\n  margin: 0;\n  font-weight: normal;\n  font-family: 'Circular', sans-serif;\n  text-transform: none;\n}\n\n/* Farben für einzelne Bereiche */\n.area-card.arbeit {\n  background-color: #F4AF20;\n}\n\n.area-card.freizeit {\n  background-color: #ee5522;\n}\n\n.area-card.listen {\n  background-color: #0077c8;\n}\n\n.area-card.kinder {\n  background-color: #648202;\n}\n\n.area-card.parlament {\n  background-color: #0074B3;\n}\n\n.area-card.logistik {\n  background-color: var(--logistik);\n}\n\n\n\n/* Login Screen */\n.login-screen {\n  height: 100vh;\n  background-color: #DDE8B9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n\n.login-screen form {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n}\n\n.login-screen input {\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n  padding: 0.5rem;\n  border-radius: 6px;\n  border: 1px solid #aaa;\n  font-family: 'Circular', sans-serif;\n}\n\n.login-screen button {\n  background-color: #648202;\n  color: #FFFFFF;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: normal;\n  font-family: 'Circular', sans-serif;\n  text-transform: uppercase;\n}\n\n.login-screen button:hover {\n  background-color: #5a7502;\n}\n\n.area-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex-grow: 1;\n  width: 100%;\n  font-weight: normal;\n}\n\n.area-content h2 {\n  font-size: 1.8rem;\n  font-family: 'Staatliches', sans-serif;\n  margin: 0 0 1rem 0;\n  text-transform: uppercase;\n  color: white;\n  text-align: left;\n  font-weight: normal;\n}\n\n/* Beschreibung */\n.area-content p {\n  font-size: 1rem;\n  color: white;\n  line-height: 1.5;\n  margin: 0;\n  text-align: left !important;\n  font-weight: normal;\n  font-family: 'Circular', sans-serif;\n  text-transform: none;\n}\n\n.footer-link {\n  text-align: center;\n  margin-top: 2rem;\n  font-size: 1rem;\n}\n\n.footer-link a {\n  color: #00509E;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  font-weight: normal;\n  transition: color 0.2s ease;\n}\n\n.footer-link a:hover {\n  color: #e48f2d;\n}\n\n@media (max-width: 768px) {\n  .area-container {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .area-icon {\n    font-size: 8rem !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .area-card {\n    min-height: 300px;\n  }\n\n  .area-icon {\n    font-size: 6rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
